var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadAndWaitAPNTag } from "../apntag/index";
import { CMP } from "../cmp/index";
import { getGeo } from "../geo/index";
import { getKeywords } from "../keywords/index";
import { getUser } from "../user/index";
export function createWrapper(window_1, member_1) {
    return __awaiter(this, arguments, void 0, function* (window, member, keywords = {}) {
        window.apntag = window.apntag || {};
        window.apntag.anq = window.apntag.anq || [];
        const { hasOptedOut } = yield (new CMP(window)).getResponse();
        const syncEnabled = !hasOptedOut;
        const user = getUser(hasOptedOut);
        const endpoint = hasOptedOut ? 'https://ib.adnxs-simple.com' : 'https://ib.adnxs.com';
        const [extInvCode, apntag] = yield Promise.all([
            getGeo(),
            loadAndWaitAPNTag(hasOptedOut),
        ]);
        apntag.setEndpoint(endpoint, true);
        apntag.setPageOpts({
            member,
            user,
            keywords,
            disablePsa: true,
            trackingManagement: {
                userSync: {
                    syncEnabled,
                },
            },
        });
        return {
            defineTag(targetId, invCode, sizes, addKeywords = {}) {
                const keywords = getKeywords(window, addKeywords);
                return apntag.defineTag({
                    member,
                    keywords,
                    targetId,
                    invCode,
                    extInvCode,
                    sizes,
                });
            },
            defineVideoTag(targetId, invCode, sizes, addKeywords = {}) {
                const keywords = getKeywords(window, addKeywords);
                return apntag.defineTag({
                    member,
                    keywords,
                    targetId,
                    invCode,
                    extInvCode,
                    sizes,
                    allowedFormats: ['video'],
                    video: {
                        frameworks: [1, 2],
                    },
                });
            },
            showTag(targetId) {
                return apntag.showTag(targetId);
            },
            loadTags(targetIds) {
                return apntag.loadTags(targetIds);
            },
            refresh(targetIds) {
                return apntag.refresh(targetIds);
            },
            onEvent(name, second, third) {
                return third ? apntag.onEvent(name, second, third) : apntag.onEvent(name, second);
            },
            offEvent(name, targetId) {
                return apntag.offEvent(name, targetId);
            },
            setKeywords(targetId, keywords) {
                return apntag.setKeywords(targetId, getKeywords(window, keywords), { overrideKeyValue: true });
            }
        };
    });
}
